import React from 'react';
import { withRouter } from 'react-router-dom';
import PageMessage from '../../atoms/pageMessage';

const PageNotFound = () => {
  return <PageMessage type="danger" message="404 Page not found!" />;
};

export default withRouter(PageNotFound);
